import type { ReactElement } from 'react'

import { DocumentMeta } from '../../DocumentMeta'
import Link from '../../templateComponents/Link'

type Props = {
  error: {
    message: string
    statusCode: number
    requestId: string | null
  }
  shop: Frontend.Shop
} & TranslateProps

export default function ErrorComponent({ t, error, shop }: Readonly<Props>): ReactElement {
  const title = t('views.storefrontView.errorPageSection.errorcode', { code: error.statusCode })
  return (
    <>
      <DocumentMeta title={`${title} - ${shop.title}`} />
      <div className="error-page">
        <section className="section">
          <div className="wrapper">
            <div className="content">
              <h1>{title}</h1>
              <div className="error-page-info">
                <h3>
                  {t(
                    error.statusCode === 404
                      ? 'views.storefrontView.errorPageSection.error404'
                      : 'views.storefrontView.errorPageSection.error500',
                  )}
                </h3>
                {error.requestId && error.statusCode >= 500 && (
                  <p className="error-page-info-explanation">
                    {t('views.storefrontView.errorPageSection.idExplanation')} <code>{error.requestId}</code>
                  </p>
                )}
                <p>
                  <Link to={shop.href} className="error-page-info-link">
                    {t('views.storefrontView.returnToStartpageLink.label')}
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  )
}
